import React from "react";
import Header from "./header/Header";
import PageFooter from "./PageFooter";
import BottomNavbar from "./BottomNavbar";
import { HiCursorClick } from "react-icons/hi";
import { FaDiscord } from "react-icons/fa6";
import { usePathname } from "next/navigation";

const Layout = ({ children }) => {
  const isBannerShown = false;
  const pathname = usePathname();

  return (
    <>
      <div>
        {isBannerShown && pathname !== "/app" && (
          <div
            role="button"
            tabIndex="0" // Make the div focusable
            // onKeyDown={handleKeyPress}
            onClick={() => {
              window.open("https://app.jammable.com", "_blank");
            }}
            style={{
              backgroundColor: "#7289da",
            }}
            className="tw-w-full tw-font-bold tw-text-white tw-h-6 tw-cursor-pointer  tw-flex tw-items-center tw-justify-center tw-fixed tw-top-0 t tw-z-[100] tw-uppercase tw-text-sm"
          >
            <FaDiscord size={18} style={{ marginRight: 4 }} />
            Mashup App IOS Beta Discord
            <HiCursorClick size={18} style={{ marginLeft: 4 }} />
          </div>
        )}
        {pathname !== "/app" && !pathname.includes("/post") && (
          <>
            <Header isBannerShown={isBannerShown} />
            <BottomNavbar />
          </>
        )}
      </div>
      <main className="tw-w-full   tw-scrollbar-thumb-gray-200  tw-scrollbar-thumb-rounded-xl  tw-scrollbar-track-gray-100 tw-scrollbar-thin tw-scrollbar-track-transparent">
        {children}
      </main>
      <PageFooter />
    </>
  );
};

export default Layout;
